/**
 * Utility functions for URL handling and slug generation
 */

export const createSlug = (text) => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // Remove special characters
    .replace(/[\s_-]+/g, '-') // Replace spaces and underscores with hyphens
    .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
};

export const encodeUrlParam = (text) => {
  return encodeURIComponent(text);
};

export const decodeUrlParam = (text) => {
  return decodeURIComponent(text);
};

export const buildUnitUrl = (unitName) => {
  return `/unit/${createSlug(unitName)}`;
};
